import { Env } from "../env";
import { ApiClient } from "../http/api_client"

export class KeywordSuggestRepository {
  async getKeywordHistorySuggest(): Promise<Document> {
    return ApiClient.get(
      Env.SETTING.clubApi.urlBase +
      'ctg/apiKeywordSuggestNew/execute?dispHistSggstFlg=true',
      {responseType: 'document'} // 現行APIのレスポンスはXMLのためdocumentで受け取る
    );
  }

  async getKeywordSuggest(searchword: string): Promise<Document> {
    return ApiClient.get(
      Env.SETTING.clubApi.urlBase +
      `ctg/apiKeywordSuggestNew/execute?keyword=${encodeURIComponent(encodeURIComponent(searchword))}`,
      {responseType: 'document'} // 現行APIのレスポンスはXMLのためdocumentで受け取る
    );
  }
}
